interface RichTextProps {
    children: string;
    className?: string;
}

export function RichText({children, className}: RichTextProps) {
    return (
        <div
            dangerouslySetInnerHTML={{__html: children}}
            className={className}
        />
    );
}
